'use client';

import { Routes } from '@/app/enums';
import { envs } from '@/app/utils/envs';
import Link from 'next/link';
import { useMemo } from 'react';
import { Trans } from 'react-i18next';

const baseUrl = envs.redirectUrl;
const slug = Routes.SUPPORT_DONIO_WITH_TWO_PERCENTS;

export const SupportDonioBanner = () => {
  const link = useMemo(() => {
    if (baseUrl && baseUrl.endsWith('/')) {
      return `${baseUrl}${slug}`;
    }

    return `${baseUrl}/${slug}`;
  }, []);

  return (
    <div className="w-full text-[16px] py-[12px] bg-primary-light text-center">
      <Trans i18nKey={'components.SupportDonioBanner.title'}>
        <Link href={link} className="text-primary-mid font-medium">
          Věnujte 2 % Donio
        </Link>{' '}
        a podpořte důležité příběhy
      </Trans>
    </div>
  );
};
